const requestInterceptorHandlers = [];
const responseInterceptorHandlers = [];
const errorHandlers = [];

export const registerRequestInterceptor = (interceptorHandler) => {
    requestInterceptorHandlers.push({
        interceptorHandler,
    });
};

export const registerResponseInterceptor = (interceptorHandler) => {
    responseInterceptorHandlers.push({
        interceptorHandler,
    });
};

export const registerErrorHandler = (errorHandler) => {
    if (errorHandler) {
        errorHandlers.push({
            errorHandler,
        });
    }
};

export const getRequestInterceptorHandlers = () => requestInterceptorHandlers;
export const getResponseInterceptorHandlers = () => responseInterceptorHandlers;
export const getErrorHandlers = () => errorHandlers;
